//Default constants for the API URL and AUTH_TOKEN name for local storage
export const HOST = "http://146.190.194.29:80";
export const AVATAR_API = "https://ui-avatars.com/api";
export const METADATA_API =
  // "https://aria-sg-products.s3-ap-southeast-1.amazonaws.com/metadata.all.json";
  "https://aria-sg-products.s3-ap-southeast-1.amazonaws.com/metadata.json";
export const API = HOST + "/api";
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";
export const GRAPHQL = HOST + "/graphql";

export const HEADER_HEIGHT = "76px";
